export const MentalForm = () => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center p-4">
      <p className="text-xl font-bold text-primary">Coming soon</p>
    </div>
  )
}
